import React from 'react'
import { useInput } from 'react-admin'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
} from '@mui/material'

const VoiceMultiSelectInput = ({ source, label, choices, ...props }) => {
  const {
    field: { value = [], onChange },
    fieldState: { error, invalid },
  } = useInput({ source, ...props })

  const handleChange = event => {
    onChange(event.target.value)
  }

  return (
    <FormControl fullWidth variant="standard" error={invalid}>
      <InputLabel id={`${source}-label`}>{label}</InputLabel>
      <Select
        labelId={`${source}-label`}
        multiple
        value={value || []}
        onChange={handleChange}
        renderValue={selected =>
          selected && (
            <Box
              sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, padding: 1 }}>
              {selected.map(selectedValue => (
                <Chip key={selectedValue} label={selectedValue} size="small" />
              ))}
            </Box>
          )
        }>
        {choices?.map(choice => (
          <MenuItem key={choice} value={choice}>
            {choice}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <div style={{ color: 'red', fontSize: '0.75rem' }}>{error.message}</div>
      )}
    </FormControl>
  )
}

export default VoiceMultiSelectInput
